<template>
  <v-form v-if="model" ref="form">
    <v-row>
      <v-col>
        <div class="text-subtitle-1 font-weight-bold">
          {{ editing ? 'Editar' : 'Criar' }} Tipo de Ingresso
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="model.name"
          label="Nome"
          :rules="[required]"
          :readonly="false"
          :disabled="FreeTypes.includes(originalName) || loader.loading"
          :title="model.name"
          variant="outlined"
          density="compact"
          hide-details
        />
      </v-col>
      <v-col cols="12" sm="4" md="2">
        <currency-field
          v-model="model.price"
          label="Preço"
          :readonly="false"
          :disabled="loader.loading || FreeTypes.includes(originalName)"
          variant="outlined"
          density="compact"
          hide-details
        />
      </v-col>
      <v-col cols="12" sm="4" md="2">
        <v-text-field
          v-model="model.passport_amount"
          label="Quantidade"
          :rules="[
            required,
            greaterThan(0)
          ]"
          :readonly="false"
          :disabled="loader.loading || FreeTypes.includes(originalName)"
          variant="outlined"
          density="compact"
          hide-details
        />
      </v-col>
      <v-col cols="12" sm="4" md="2">
        <v-text-field
          v-model="model.max_installments"
          label="Max. Parcelas"
          :rules="[
            required,
            greaterThan(0)
          ]"
          :readonly="false"
          :disabled="loader.loading || FreeTypes.includes(originalName)"
          variant="outlined"
          density="compact"
          hide-details
        />
      </v-col>
      <v-col cols="12" sm="4" md="2">
        <v-text-field
          v-model="model.max_per_user"
          label="Max. Por Comprador"
          :rules="[
            greaterThan(0)
          ]"
          :readonly="false"
          :disabled="loader.loading || FreeTypes.includes(originalName)"
          variant="outlined"
          density="compact"
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="model.observations"
          label="Observação"
          :readonly="false"
          :disabled="loader.loading"
          variant="outlined"
          density="compact"
          hide-details
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-select
          v-model="model.integration_tiers"
          :items="integrations"
          item-title="name"
          item-value="id"
          label="Integrações"
          :readonly="false"
          :disabled="loader.loading || FreeTypes.includes(originalName)"
          variant="outlined"
          density="compact"
          hide-details
          multiple
          return-object
          chips
          clearable
        />
      </v-col>
    </v-row>
    <!-- <v-row>
      <v-col v-for="(image, index) in model.images" :key="index" md="3">
        <card-image-picker
          v-model="f"
          label="Imagens do Tipo de Ingresso"
          description="Imagens que serão exibidas no voucher e outros materiais de comunicação."
          :dimensions="{ width: 150, height: 150 }"
          :disabled="loader.loading"
        />
      </v-col>
    </v-row> -->
    <v-row justify="end">
      <v-col cols="12" sm="6" md="2">
        <v-btn
          color="primary"
          class="w-100"
          :loading="loader.loading"
          :disabled="loader.loading"
          @click="emit('cancel')"
        >
          Cancelar
        </v-btn>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-btn
          color="primary"
          class="w-100"
          :loading="loader.loading"
          :disabled="loader.loading"
          @click="save"
        >
          Salvar
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script setup lang="ts">
import { onMounted, Ref, ref, useTemplateRef } from 'vue'
import { useLoader } from '@/stores/loader'
import { FreeTypes } from '@/constants/TicketTypeNames'
import TicketType from '@/types/TicketType'
import CurrencyField from '@/components/form/CurrencyField.vue'
import type { VForm } from 'vuetify/lib/components'
import { useSnackBar } from '@/stores/snackbar'
import { greaterThan } from '@/helpers/rules/greaterThan'
import { required } from '@/helpers/rules/required'
import IntegrationService from '@/services/IntegrationService'
import IntegrationTier from '@/types/IntegrationTier'

const loader = useLoader()
const snackbar = useSnackBar()

const emit = defineEmits(['submit', 'cancel'])

const model = defineModel<TicketType>()

const { editing = false } = defineProps<{ editing?: boolean }>()

const form = useTemplateRef<VForm>('form')

const integrations: Ref<IntegrationTier[]> = ref([])

async function save() {
  if (!model.value) return

  const validated = await form.value?.validate()

  if (!validated?.valid) {
    const messages = validated?.errors.flatMap(e => e.errorMessages).join('. ') ?? ''

    snackbar.show(messages, 'error')
    return
  }

  emit('submit')
}

async function fetchIntegrations() {
  try {
    loader.increment()
    const service = new IntegrationService()
    integrations.value = (await service.index()).data.data.flatMap(
      i => i.tiers,
    )
  } catch {
    snackbar.show('Erro ao carregar integrações', 'error')
  } finally {
    loader.decrement()
  }
}

const originalName = ref('')

onMounted(() => {
  originalName.value = model.value?.name ?? ''
  fetchIntegrations()
})
</script>
